<iframe
	*ngIf="url"
	[src]="url"
></iframe>
